module.exports = __webpack_public_path__ + "static/img/3.115d66f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/sp/3.png
// module id = ox1c
// module chunks = 0